import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import Colors from "../../assets/colors/Colors";

const posTextArea = defineStyle({
    borderRadius: "0.31rem",
    border: "1px solid" + Colors.commonInputBorder,
    fontSize: "0.94rem",
    fontWeight: 300,
    background: Colors.comsmonInputBackground,
    _placeholder: {
      fontSize: "0.94rem",
      fontWeight: 300,
      color: "#01004821",
    },
    _focus: {
      border: "0.125rem solid",
      borderColor: Colors.buttonHover,
      boxShadow: "0rem 0rem 0rem 0.188rem " + Colors.inputHover,
       // borderColor: "#6366f1", TODO as per dropdown.
      // boxShadow: "0 0 0 0.2rem #c7d2fe !important", 
    },
    _invalid: {
      border: "0.125rem solid",
      borderColor: Colors.inputErrorBorder,
      boxShadow: "0px 0px 0px 3px " + Colors.badgeError,
    },
})

export const textareaTheme = defineStyleConfig({
  variants: { posTextArea },
})